
import { defineComponent } from 'vue'
import OriginalPaper from '@/components/en/publication/OriginalPaper.vue'
import ReviewPaper from '@/components/en/publication/ReviewPaper.vue'
import BookList from '@/components/en/publication/BookList.vue'
import ThesisList from '@/components/en/publication/ThesisList.vue'

export default defineComponent({
  name: 'PublicationEn',
  components: {
    OriginalPaper,
    ReviewPaper,
    BookList,
    ThesisList
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'publication'
    }
  }
})
